<p *ngIf="langue.l == 'fr'">
    Initiative : <b>1d12 + Agilité</b> -> ordre décroissant = ordre de combat<br/>
    Chaque personne commence son tour avec sa valeur de base de points d'action (PA) et de points de réactions (PR)<br/>
    Un aventurier de base possède une <b>base de 5 PA</b> et sa <b>Dextérité / 2</b> (arrondi en haut) <b>en PR</b>.<br/>
    <b>Il est possible de dépasser ces valeurs de bases</b>,
    comme par exemple utiliser la capacité Action Surge (+4 PA), ou bien consommer 1 PA pour obtenir 1 PR additionnel.<br/>
    Pendant son tour, le personnage peut consommer ses PA pour effectuer des actions correspondantes.
    Hors de son tour, un personnage peut consommer ses PR pour effectuer des réactions quand il obtient une opportunité.<br/>
    Les actions et réactions s'effectuent point par point. Les réactions sont effectuées dès la fin de l'action qui a créé l'opportunité.<br/>
    La plupart des action faites au contact d'un ennemi provoquent une opportunité de la part de l'ennemi.
    Des exemples d'actions qui créent des opportunités : invoquer de la magie, utiliser un objet, courir, attaquer une autre cible au contact, faire une attaque à distance.
    Les actions qui ne créent pas d'opportunité sont : attaquer cet ennemi au contact, marcher.<br/>
    Exemple : Trois personnes sont alignées : A - B - C.
    Si B attaque A, alors C obtient une réaction. Dans ce cas, C peut attaquer B, ou bien partir en courant.<br/>
    <b>Les réactions ne provoquent pas d'opportunités.</b><br/>
    À la fin de son propre tour, un personnage peut consommer <b>un</b> PA pour gagner <b>un</b> PR (<b>une</b> fois par tour).
    Au début du tour, tous les PR non utilisés sont perdus, et les PR reviennent à leur valeur de base
    (sauf si le personnage se concentre sur un préparation, cf plus bas).<br/>
    <br/>
    <b>Définition de tour de combat :</b> le <b>tour d'un joueur</b> représente le moment où le personnage peut prend des actions (qui coûtent des PA).<br/>
    Le <b>tour global</b> représente le temps que chaque créature dans le combat prenne son tour exactement une fois. Il représente aussi un "tour complet" de l'initiative.<br/>

</p>
<p *ngIf="langue.l == 'en'">
    Initiative : 1d12 + Agility -> descending = turn order<br/>
    Each person starts their turn with their base value of action points (AP) and reaction points (RP)<br/>
    A basic adventurer has a base value of 5 AP and half their dexterity (rounded up) in RP.<br/>
    <b>It is possible to go beyond these base values</b>,
    with for example the Action Surge skill (+4 AP), or by consuming 1 AP to get 1 additional RP.<br/>
    During their turn, the character can consume their AP to do the corresponding actions (see table below).
    Outside their turn, they can use RP to do reactions when they get an opportunity.<br/>
    Actions and reactions are done point by point. Reactions are resolved right after the action that created the opportunity.<br/>
    Most actions done while in contact with an enemy will give this enemy an opportunity.
    Examples of actions which will create opportunities : invoking magic, using an item, running.
    Actions that do not create opportunities are : attacks to this enemy, walking.<br/>
    Reactions do not create opportunities.<br/>
    At the end of their turn, a character can consume 1 AP to gain 1 RP (once per turn).
    At the beginning of their turn, all non-used RP are lost, and RP are returned to their default value
    (except if the character is focusing on a preparation, see below).<br/>
</p>

<div class="div-table" *ngIf="langue.l == 'fr'">
    <table>
        <tr>
            <th>Action</th>
            <th>Prix PA</th>
            <th>Prix PR</th>
        </tr>
        <tr>
            <td>parler</td>
            <td>0</td>
            <td>0</td>
        </tr>
        <tr>
            <td>intéragir, utiliser un objet</td>
            <td>1</td>
            <td>1</td>
        </tr>
        <tr>
            <td>se déplacer*</td>
            <td>1</td>
            <td>1</td>
        </tr>
        <tr>
            <td>attaque arme légère</td>
            <td>2</td>
            <td>1</td>
        </tr>
        <tr>
            <td>attaque arme normale</td>
            <td>3</td>
            <td>2</td>
        </tr>
        <tr>
            <td>attaque arme lourde</td>
            <td>4</td>
            <td>3</td>
        </tr>
        <tr>
            <td>magie</td>
            <td>3-4**</td>
            <td>2</td>
        </tr>
    </table>
</div>
<div class="div-table" *ngIf="langue.l == 'en'">
    <table>
        <tr>
            <th>Action</th>
            <th>Cost AP</th>
            <th>Cost RP</th>
        </tr>
        <tr>
            <td>talk</td>
            <td>0</td>
            <td>0</td>
        </tr>
        <tr>
            <td>interact, use an object</td>
            <td>1</td>
            <td>1</td>
        </tr>
        <tr>
            <td>move*</td>
            <td>1</td>
            <td>1</td>
        </tr>
        <tr>
            <td>light attack</td>
            <td>2</td>
            <td>1</td>
        </tr>
        <tr>
            <td>medium attack</td>
            <td>3</td>
            <td>2</td>
        </tr>
        <tr>
            <td>heavy attack</td>
            <td>4</td>
            <td>3</td>
        </tr>
        <tr>
            <td>magic</td>
            <td>3-4**</td>
            <td>2</td>
        </tr>
    </table>
</div>

<p *ngIf="langue.l == 'fr'">
    *= se déplacer peut se faire de 2 façons : marcher et courrir. Marcher permet de se déplacer de 1 case par point dépensé, et courrir 2 cases par point.<br/>
    **= selon la magie, cf <a routerLink="/system/magic/explanation" routerLinkActive="activebutton">magie</a><br/>
</p>
<p *ngIf="langue.l == 'en'">
    *= moving can be done 2 ways : walking and running. Walking allows to move 1 square per spent point, and running 2 squares per point.<br/>
    **= depending on the magic, see <a routerLink="/system/magic/explanation" routerLinkActive="activebutton">magic</a><br/>
</p>

<h3 *ngIf="langue.l == 'fr'">Préparer une action</h3>
<h3 *ngIf="langue.l == 'en'">Preparing an action</h3>

<p *ngIf="langue.l == 'fr'">
    Une action possible est de se préparer.<br/>
    Cette action coûte 1PA et permet ensuite de transférer un nombre non limité de PA en PR (avec un ratio de 1 pour 1).
    Le joueur déclare un déclencheur qui s'ajoute à la liste des actions qui provoquent des opportunités.<br/>
    À partir de ce moment, le joueur est en concentration.<br/>
    Quand la concentration est levée, le déclencheur est enlevé de la liste et les PR non utilisés sont perdu.<br/>
    Un joueur peut ainsi garder des PR d'un tour à l'autre simplement en dépensant 1PA pour rester concentré.<br/>
    Une liste non exhaustive d'exemples de nouveau déclencheurs : la fin de son tour, quand un ennemi arrive à proximité,
    quand un ennemi arrive en ligne de vue, quand un allié arrive à proximité, quand un ennemi fait une attaque, quand une personne fait une action particulière.<br/>
    Pour utiliser un autre déclencheur, il faut voir ce que le MJ accepte.<br/>
</p>
<p *ngIf="langue.l == 'en'">
    One possible action is to prepare.<br/>
    This action costs 1AP and allows the player to transfer any number of AP into RP.
    The player declares a trigger which is added to the list of actions that create opportunities.<br/>
    At this moment, the player becomes concentrated.<br/>
    When the concentration ends, the trigger is removed and any non used RP are lost.<br/>
    This way, a player can keep RPs from one turn to another by simply spending 1AP to stay concentrated.<br/>
</p>
